<template>
    <RouterLink
        to='/admin/tenants?sort=[{"column":"created_at","direction":"desc"}]'
        class="block py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
    >
        <div class="flex items-center">
            <div class="w-6 ml-1">
                <FontAwesomeIcon :icon="['fal', 'users-crown']" class="size-4!" />
            </div>
            <div class="ml-2 text-xs">Administration</div>
        </div>
    </RouterLink>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
